import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import Cart from './components'
import { useSelector } from 'react-redux'
import { IReducer } from './interface'

const CartRoutes = () => {
  const cartReducer = useSelector((state: IReducer) => state.cartReducer)
  const { isCartLoading } = cartReducer

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('isCartLoading', { detail: isCartLoading }))
  }, [isCartLoading])

  return (
    <Routes>
      <Route path='*' element={<Cart />} />
    </Routes>
  )
}

export default CartRoutes
